
import { D2lTinyMceEditorController } from 'src/integration/api/ui/annotators/d2l/wysiwyg/D2lTinyMceEditorController';
import { GenericTinyMceEditorController } from 'src/shared/wysiwyg/tinymce/GenericTinyMceEditorController';
import { ITinyMceEditorFacade } from 'src/shared/wysiwyg/tinymce/ITinyMceEditorFacade';
import { LearnTinyMceEditorController } from 'src/shared/wysiwyg/tinymce/LearnTinyMceEditorController';
import { TinyMceEditorController } from 'src/shared/wysiwyg/tinymce/TinyMceEditorController';

const AllyConfig = require('src/shared/rest/Config');

export function getTinyMceEditorController(
    baseUrl: string,
    i18n: any,
    facade: ITinyMceEditorFacade,
    hideAccessibilityPlugin: boolean,
    isNewLessonsExperience?: boolean
): TinyMceEditorController {
    switch (AllyConfig.lmsType() == null ? undefined : AllyConfig.lmsType().toLowerCase()) {
        case 'learn':
            return new LearnTinyMceEditorController(baseUrl, i18n, facade, hideAccessibilityPlugin);
        case 'd2l':
            isNewLessonsExperience = isNewLessonsExperience ?? false;
            /* eslint-disable-next-line max-len */
            return new D2lTinyMceEditorController(baseUrl, i18n, facade, hideAccessibilityPlugin, isNewLessonsExperience);
        default:
            return new GenericTinyMceEditorController(baseUrl, i18n, facade, hideAccessibilityPlugin);
    }
}
